import { Route, Routes } from 'react-router-dom'
import { AbilityContext } from '../../components/Ability'
import { useContext } from 'react'
import NotFound from '../NotFound'
import FacebookUserInfo from './Features/FacebookUserInfo'

const FacebookPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/user-info"
        element={
          ability.can('manage', 'Facebook', 'all') ? (
            <FacebookUserInfo />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default FacebookPage
